/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_Not_ListedInputs */



/**
* | output |
* | --- |
* | "Not in the list" |
*
* @param {Manager_Question_Not_ListedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_not_listed = /** @type {((inputs?: Manager_Question_Not_ListedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_Not_ListedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Staat er niet tussen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ne figure pas dans la liste")
	return /** @type {LocalizedString} */ ("Not in the list")
});